import {} from '@angular/common/http';
import { Component } from '@angular/core';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { BaseSafeIpsIndexPageComponent } from '../base/base-safe-ips-index-page.component';
@Component({
    selector: 'app-safe-ips',
    templateUrl: './safe-ips.component.html',
    imports: [BaseIndexModule, BaseSafeIpsIndexPageComponent]
})
export class SafeIpsComponent {
  //#region Properties

  pageTitle: string = 'pages.safeIps.safeIpsTitle';
  getTableDataApiMethodName: string = 'userSafeIPsSafeIPsWithPagination';

  //#endregion

  constructor() {}
}
